import ReactGA from 'react-ga4';
import { UaEventOptions } from 'react-ga4/types/ga4';

const GA_MEASUREMENT_ID = 'G-LD8GHZS4B7';

export function gaPageview(loc: string): void {
  if (process.env.REACT_APP_ENV == 'production') {
    ReactGA.initialize(GA_MEASUREMENT_ID);
    ReactGA.send({ hitType: 'pageview', page: loc });
  } else {
    console.debug(`[GA/Pageview] ${loc}`);
  }
}

export function gaRecommend(
  result: string,
  excludedCategories: Set<string>,
  excludedFoods: Set<string>,
): void {
  const excluded: Record<string, Array<string>> = {
    excluded_categories: Array.from(excludedCategories),
    excluded_foods: Array.from(excludedFoods),
  };
  const eventParams: UaEventOptions = {
    category: result,
    action: 'recommend',
    label: JSON.stringify(excluded),
    nonInteraction: false,
    transport: 'xhr',
  };
  if (process.env.REACT_APP_ENV == 'production') {
    ReactGA.initialize(GA_MEASUREMENT_ID);
    ReactGA.event(eventParams);
  } else {
    console.debug(`[GA/Recommend] ${JSON.stringify(eventParams)}`);
  }
}

export function gaRestaurantSelect(selected: string): void {
  const eventParams: UaEventOptions = {
    category: 'restaurant',
    action: 'select',
    label: selected,
    nonInteraction: false,
    transport: 'beacon',
  };
  if (process.env.REACT_APP_ENV == 'production') {
    ReactGA.initialize(GA_MEASUREMENT_ID);
    ReactGA.event(eventParams);
  } else {
    console.debug(`[GA/Restaurant/Select] ${JSON.stringify(eventParams)}`);
  }
}

export function gaRestaurantShare(selected: string): void {
  const eventParams: UaEventOptions = {
    category: 'restaurant',
    action: 'share',
    label: selected,
    nonInteraction: false,
    transport: 'beacon',
  };
  if (process.env.REACT_APP_ENV == 'production') {
    ReactGA.initialize(GA_MEASUREMENT_ID);
    ReactGA.event(eventParams);
  } else {
    console.debug(`[GA/Restaurant/Share] ${JSON.stringify(eventParams)}`);
  }
}
